import moment from 'moment';
import { IListColumn } from '~/models/listCol';
import { cpfMask, currencyMask, phoneMask } from '~/utils/masks';

export const HeaderReportCharges = [
  {
    id: 1,
    value: 'Nome',
    maxChar: 25,
  },
  {
    id: 2,
    value: 'CPF',
    maxChar: 14,
    textAlign: 'center',
  },
  {
    id: 3,
    value: 'E-mail',
    maxChar: 25,
  },
  {
    id: 4,
    value: 'Celular',
    maxChar: 15,
    textAlign: 'center',
  },
  {
    id: 5,
    value: 'Data de Vencimento',
    textAlign: 'center',
  },
  {
    id: 6,
    value: 'Valor',
    maxChar: 10,
    textAlign: 'center',
  },
];

export const BodyReportCharges = (data: any) => {
  // let x = 0;

  const items = [];

  data.pagina?.forEach((i) => {
    const item: IListColumn[] = [
      // {
      //   type: 'id',
      //   value: x++,
      //   maxChar: 5,
      // },
      {
        value: i.nome,
        maxChar: 25,
      },
      {
        value: cpfMask(i.cpf).masked,
        maxChar: 14,
        textAlign: 'center',
      },
      {
        value: i.email,
        maxChar: 25,
      },
      {
        value: i.celular ? phoneMask(i.celular).masked : '-',
        maxChar: 15,
        textAlign: 'center',
      },
      {
        value: i.vencimento
          ? moment(i.vencimento).format('DD/MM/YYYY HH:mm')
          : '-',
        textAlign: 'center',
      },
      {
        value: `R$ ${currencyMask(i.valor)}`,
        maxChar: 10,
        textAlign: 'center',
      },
    ];
    items.push(item);
  });
  return items;
};
